import './UseTerms.css'
import { Button } from '@mui/material';

const UseTerms = ({closeUseTerms}) => {
    return(
        <div className='modal-container'>
            <div className='use-terms-box'>
                <div className='terms-title'>
                    <h1>Termos de uso e consumo</h1>
                </div>
                <hr/>
                <div className='terms-content'>
                    <p>
                        Todas as imagens e conteúdo utilizadas neste 
                        serviço atendem aos requisitos da LGPD. 
                        Nenhuma das informações serão utilizadas ou publicadas 
                        sem consentimento do(a) usuário(a). A privacidade das 
                        mesmas estão sob absoluto sigilo da empresa.
                    </p>
                </div>
                <Button style={{margin: '32px 0 0 0'}} onClick={closeUseTerms}>Fechar</Button>
            </div>
        </div>
    )
}

export default UseTerms